<nav class="app-config-top-nav" [class.hidden]="isHidden" aria-label="Application configuration navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/companies"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Companies
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/departments"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Departments
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/shifts"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Shifts
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/workertypes"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Worker Types
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/paygroups"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Pay Groups
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/pay-codes"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Pay Codes
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/rounding-rules"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Rounding Rules
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/application/holidays"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Holiday
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>